<template>
  <div class="market-component" v-iscroll>
    <div class="market-center">
      <div v-for="(item, index) in marketData" :key="index" @click="clickMarket(item.mid)" @mouseover="hovermarket=item.mid" @mouseout="hovermarket=0" :class="hovermarket===item.mid?'hover-market':''" class="market-item cursor-pointer">
        <div class="market-img"><img :src="appImg" /></div>
        <div class="market-p-box">
          <div :class="jurisdiction?'market-p-j':'market-p'">
            {{item.menu_name}}
          </div>
          <div class="market-p ">
            <div @click="clickJurisdiction" @mouseover="chooesed=item.mid" @mouseout="chooesed=-1" :class="{'jurisdiction-active':chooesed===item.mid}" class="jurisdiction" v-if="jurisdiction">
              申请权限
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {appImg} from '@/utils/imgUrl'
export default {
  data () {
    return {
      appImg,
      hovermarket: 0,
      jurisdiction: false,
      chooesed: -1
    }
  },
  props: {
    marketData: {
      type: Array,
      default: () => []
    }
  },
  created()
  {

  },
  methods: {
    clickMarket (id) {
      this.$emit('clickMarket', id)
    },
    clickJurisdiction () {
      console.log('clickJurisdiction')
    }
  }
}
</script>
<style lang="less">
@import '~assets/style/variable.less';
@import '~assets/style/mixin.less';
.market-component {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: @color-bg-main;
  overflow: hidden;
}
.market-center {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 86px 40px;
  margin: 0 auto;
  width: 1280px;
}
.hover-market {
  color: @color-theme;
  box-shadow: 0 6px 8px 0 rgba(153, 153, 153, 0.50) !important;
}
.market-item {
  background: #fff;
  width: 260px;
  height: 100px;
  display: flex;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 20px;
  box-shadow: 0 2px 2px 0 rgba(204,204,204,0.50);
  border-radius: 4px;
  font-size: @font-size-large;
  .market-img {
    width: 60px;
    height: 60px;
    margin: 0 16px 0 20px;
    .flex-center;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .jurisdiction {
    width: 74px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    font-size: @font-size-medium;
    border: 1px solid @color-highlight;
    color: @color-highlight;
    border-radius: 4px;
    letter-spacing: 0;
    margin-top: 12px;
  }
  .jurisdiction-active {
    width: 74px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    font-size: @font-size-medium;
    border: 1px solid @color-highlight;
    color: #fff;
    background: @color-highlight;
    border-radius: 4px;
    letter-spacing: 0;
    margin-top: 12px;
  }
  .market-p-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 60px;
    width: 146px;
  }
  .market-p {
    font-size: @font-size-large;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 60px;
    width: 146px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .market-p-j {
    font-size: @font-size-large;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    max-height: @font-size-large;
    width: 146px;
    line-height: @font-size-large;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appMarket.vue